import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class WebService extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/webService'
    super(store, path)
  }
}
